import axiosInstance from 'config/axiosInstance';
import { MAX_PAGE_SIZE } from 'config/constant';
import { fetchSearchPage, RemotePage } from 'reusable/RemoteSearch/remotePage';

/**
 * EV-493。配送先に割り当てる運転者の候補と、選んでいる運転者の名前。
 *
 * 以前は運転者を全件（最大5,000件・100件ずつ50回）読み、候補・選んだ運転者の名前・割当の有無
 * （client_delivery）を画面で求めていた。候補は名前で検索して20件ずつ読み、
 * 選んでいる運転者は ID で読む（id__in。会社の範囲はサーバーが守る）。
 */
export interface DriverCandidate {
  id: number;
  name: string;
  phone: string;
  profile_picture: string | null;
  /**
   * A10（2026-11-03 和田様の指摘）。割り当てている配送先の ID（複数。無ければ空）。以前は client_delivery（1つ）で、
   * ほかの配送先に割り当て済みの運転者は「割り当て済み」で選べなかった。
   */
  client_deliveries: number[];
}

/** 運転者の候補の1ページ（名前の順）。 */
export function driverCandidatePage(query: string, page: number): Promise<RemotePage<DriverCandidate>> {
  return fetchSearchPage<DriverCandidate>('/v1/drivers/', query, page, { order_by: 'name' });
}

/** 選んでいる運転者を ID で読む（100件ずつ）。読めた運転者だけを返す（削除された運転者は含まない）。 */
export async function fetchDriversByIds(ids: number[]): Promise<DriverCandidate[]> {
  const unique = Array.from(new Set(ids));
  const rows: DriverCandidate[] = [];
  for (let start = 0; start < unique.length; start += MAX_PAGE_SIZE) {
    const chunk = unique.slice(start, start + MAX_PAGE_SIZE);
    const response = await axiosInstance.get(
      `/v1/drivers/?id__in=${chunk.join(',')}&page_size=${MAX_PAGE_SIZE}`
    );
    rows.push(...(Array.isArray(response.data?.results) ? response.data.results : []));
  }
  return rows;
}
